import { connect } from 'react-redux'
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import { submitForm, stopSubmitForm, getNextStep, updateDocumentStep } from '../actions/users';
import Documents from '../components/Documents';


const mapStateToProps = (state) => {
    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        /*getStep(values, dispatch) {
            dispatch(submitForm());
            return dispatch(getNextStep()).then((result) => {
                if (typeof(result.payload.data.endpoint) !== "undefined") {
                    sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                    dispatch(stopSubmitForm());
                    if (browserHistory.getCurrentLocation().pathname === result.payload.data.endpoint) {
                        browserHistory.go(-1);
                    } else {
                        browserHistory.push(result.payload.data.endpoint);
                    }
                }
            });
        },*/
        updateDocumentStep(values, dispatch) {
            dispatch(submitForm());
            return dispatch(updateDocumentStep()).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== "undefined") {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            if (browserHistory.getCurrentLocation().pathname === result.payload.data.endpoint) {
                                browserHistory.go(-1);
                            } else {
                                browserHistory.push(result.payload.data.endpoint);
                            }
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documents);


/** WEBPACK FOOTER **
 ** ./src/containers/DocumentsContainer.js
 **/